import i18next from 'i18next'

const localStorage = typeof window === 'undefined' ? undefined : window.localStorage
const PREFERRED_LOCALE_KEY = 'locale'

const DEFAULT_LOCALE = process.env.DEFAULT_LOCALE ?? 'en'
const FALLBACK_LOCALE = process.env.FALLBACK_LOCALE ?? DEFAULT_LOCALE

function getPreffered(): string {
	return localStorage?.getItem(PREFERRED_LOCALE_KEY) ?? typeof navigator !== 'undefined'
		? navigator.language
		: DEFAULT_LOCALE
}

function getFallback() {
	return FALLBACK_LOCALE
}

function getCurrent(): string {
	return 'en-US' // i18next.language
}

function setCurrent(locale: string): void {
	if (typeof window !== 'undefined') {
		localStorage?.setItem(PREFERRED_LOCALE_KEY, locale)
	}

	i18next.changeLanguage(locale)
}

function getCurrentHierarchy(): string | string[] {
	const locale = getCurrent()
	return locale === FALLBACK_LOCALE ? locale : [locale, FALLBACK_LOCALE]
}

export default {
	getPreffered,
	getCurrent,
	setCurrent,
	getCurrentHierarchy,
	getFallback,
}
